// Author Liu Cui Cui
// Date 2023-10-12 14:20:11

class SithMesTpmSpindleDataTsd {
    constructor({
                    id = null,
                    tsdSpindleSpeed = '',
                    tsdSpindleOverride = '',
                    tsdSpindleLoad = '',
                    tsdSpindleState = '',
                    tsdFeedSpeed = '',
                    tsdFeedOverride = '',
                    tsdGeometricX = '',
                    tsdGeometricY = '',
                    tsdGeometricZ = '',
                    tsdOperatorId = '',
                    tsdOperatorName = '',
                    tsdOperateSeq = '',
                    tsdLocationId = '',
                    tsdCollectTime = '',
                    tsdDeviceCode = '',
                    tsdDeviceSystemType = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.tsdSpindleSpeed = tsdSpindleSpeed;
        this.tsdSpindleOverride = tsdSpindleOverride;
        this.tsdSpindleLoad = tsdSpindleLoad;
        this.tsdSpindleState = tsdSpindleState;
        this.tsdFeedSpeed = tsdFeedSpeed;
        this.tsdFeedOverride = tsdFeedOverride;
        this.tsdGeometricX = tsdGeometricX;
        this.tsdGeometricY = tsdGeometricY;
        this.tsdGeometricZ = tsdGeometricZ;
        this.tsdOperatorId = tsdOperatorId;
        this.tsdOperatorName = tsdOperatorName;
        this.tsdOperateSeq = tsdOperateSeq;
        this.tsdLocationId = tsdLocationId;
        this.tsdCollectTime = tsdCollectTime;
        this.tsdDeviceCode = tsdDeviceCode;
        this.tsdDeviceSystemType = tsdDeviceSystemType;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesTpmSpindleDataTsd();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleSpeed',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleSpeed',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleOverride',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleOverride',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleLoad',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleLoad',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleState',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleState',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdFeedSpeed',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdFeedSpeed',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdFeedOverride',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdFeedOverride',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricX',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdGeometricX',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricY',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdGeometricY',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricZ',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdGeometricZ',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleAload',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleAload',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleC1load',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdSpindleC1load',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOperatorName',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdOperatorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeptName',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdDeptName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdProjectCode',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdProjectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdItemName',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdItemName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOrderCode',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpOperationName',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.prdPpOperationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdMstLocName',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdMstLocName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdCollectTime',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdCollectTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeviceCode',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdDeviceCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeviceSystemType',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.tsdDeviceSystemType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    tsdSpindleSpeedFilter: '',
    tsdSpindleOverrideFilter: '',
    tsdSpindleLoadFilter: '',
    tsdSpindleStateFilter: '',
    tsdFeedSpeedFilter: '',
    tsdFeedOverrideFilter: '',
    tsdOperatorIdFilter: '',
    tsdOperatorNameFilter: '',
    tsdDeptNameFilter: '',
    tsdProjectCodeFilter: '',
    tsdItemNameFilter: '',
    tsdOrderCodeFilter: '',
    tsdOperateSeqFilter: '',
    prdPpOperationNameFilter: '',
    tsdLocationIdFilter: '',
    tsdMstLocNameFilter: '',
    tsdCollectTimeRteFilter: '',
    tsdCollectTimeLteFilter: '',
    tsdDeviceCodeFilter: '',
    tsdDeviceSystemTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'tsdOperatorIdFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOperatorId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tsdOperatorNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOperatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeptNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdDeptName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdProjectCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdProjectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdItemNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdItemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOrderCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.prdPpOperationName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdMstLocNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdMstLocName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdCollectTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdCollectTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdDeviceCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceSystemTypeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdDeviceSystemType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const spindleDataImageFilterConfigs = [
    {
        key: 'tsdOperatorIdFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOperatorId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tsdOperatorNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOperatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdProjectCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdProjectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdItemNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdItemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOrderCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.prdPpOperationName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdMstLocNameFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdMstLocName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdCollectTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdCollectTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.filter.tsdDeviceCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'tsdSpindleSpeed',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleSpeed',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleOverride',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleOverride',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleLoad',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleLoad',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleState',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleState',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdFeedSpeed',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdFeedSpeed',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdFeedOverride',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdFeedOverride',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricX',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdGeometricX',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricY',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdGeometricY',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricZ',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdGeometricZ',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleAload',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleAload',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleC1load',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdSpindleC1load',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOperatorName',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdOperatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"tsdOperatorId":"id"}'
        }
    },
    {
        key: 'tsdOperateSeq',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdOperateSeq',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpOperation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tsdLocationId',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdLocationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tsdCollectTime',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdCollectTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceCode',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdDeviceCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.tsdDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmSpindleDataTsd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesTpmSpindleDataTsd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, spindleDataImageFilterConfigs


}
